import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { Store } from '../../../store/player/types';
import { onPlayTick } from './onPlayTick';

/**
 * Toggle the recording speed.
 * Toggling changes the speed from 1 -> 2 -> 4 -> 0.5 -> 1 ...
 */
export const togglePlaybackSpeed = (store: Store): void => {
  const { playbackScript, playTimeoutId, playbackSpeed, playing, setPlaybackSpeed } =
    store.getState();

  const recordingSpeeds = [1, 2, 4, 0.5];
  const currentRecordingSpeedIndex = recordingSpeeds.indexOf(playbackSpeed);

  const newPlaybackSpeed =
    recordingSpeeds[(currentRecordingSpeedIndex + 1) % recordingSpeeds.length];
  setPlaybackSpeed(newPlaybackSpeed);
  LocalStorage.set('playbacksPlaybackSpeed', newPlaybackSpeed);
  playbackScript.adjustSpeed(newPlaybackSpeed);

  if (playing) {
    if (playTimeoutId) clearTimeout(playTimeoutId);
    onPlayTick(store);
  }
};
